import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import classnames from "classnames";
import DropDownListselect from '../../components/dropdown';
import AvailablityDropdown from '../../components/availablityDropdown';
import Styles from "./styles.module.scss";
import { DropDownInput } from "../../wrappers/selectInput";
import { getDetails, updateAvailablity } from "./services";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import { checkTimesheetStatus } from "../../utils/EllowUtils"



function DashboardHeader(props: any) {

  const openMobileMenu = () => {
    document.body.classList.add('mobileMenu');
  }


  const loginId = localStorage.getItem('loginId') 

  const [id, setId] = useState<any> ()
  const [availableSettings, setAvailabbleSettings] = useState<boolean>(false)

  const navigate = useNavigate()
  
  const onClick = ( data: any) => {
    navigate('/my-profile', {state:{selector : 2}})
    props.redirectToAvailability()
  }

  const redirectHeader = () => {
    navigate(props.navigateTo)
  }
  
  
  return (
    <div className={Styles.dashHead}>
      {/* <button className={Styles.backBtn}><Icon icon="ep:arrow-left-bold" />HOME</button> */}
      <div className={Styles.mobileHead}>
        <div className={Styles.mobileHeadWrap}>
          <button className={Styles.mobileMenu} onClick={openMobileMenu}><Icon icon="radix-icons:hamburger-menu" /></button>
          <Link to="/dashboard"><img src={ellowLogo} alt="ellow.io" /></Link>
        </div>
        {props.title && <div className={Styles.timeSheetHead}>
        <h3>
          { props.title}
          <span>{props.positionTitle ? props.positionTitle : ''}</span>
        </h3>
        { props.timesheetStatus && 
            <div className={checkTimesheetStatus(props.timesheetStatus).class}>
              {checkTimesheetStatus(props.timesheetStatus).value}
            </div>
          }
        </div>}
      </div>
      <div className={classnames('availableDropdown', Styles.available)}>
        <AvailablityDropdown onClick={onClick} drop={props.dropdown} />
      </div>
      <div className={Styles.notification}>
        <Link to='/help'>
          <Icon icon="charm:help" />
        </Link>
        <Link to='/settings'>
          <Icon icon="tabler:settings" />
        </Link>
        {/* <Link to="#">
          <Icon icon="iconoir:bell" />
        </Link> */}
      </div>
    </div>
  );
}

export default DashboardHeader;
